import { TrendUp } from 'Assets/icons/TrendUp'
import React from 'react'
import i18n from 'Lib/i18n'

const i18nText = (key: string) => i18n.t(`boxes.${key}`, { ns: 'limitedOfferBanner' })

export const boxesContent = [
  {
    text: i18nText('1.title'),
    value: i18nText('1.value'),
    style: { top: '80px', right: 'calc(45% - 20px)', width: '140px' },
  },
  {
    text: i18nText('2.title'),
    value: (
      <span>
        <>
          {i18nText('2.value')}
          <TrendUp style={{ marginLeft: '8px' }} />
        </>
      </span>
    ),
    style: { top: '44px', right: 'unset', left: 'calc(55% + 60px)', width: '102px' },
  },
]
